import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as signalR from "@microsoft/signalr";
import { ReplaySubject, Observable, throwError, map, catchError } from "rxjs";

import { UserActivityService } from "../../user-activity.service";
import { UserService } from "../../user.service";
import { WebApiService } from "../../WebApiService";
import { DocumentData } from "../IDatabase";
import { ChangeListener, ProgressListener, MongoBody, httpOptions, QueryOperation } from "./http-mongo";
import { environment } from "../../../../../../src/environments/environment";
import { LocalServerStatus } from "@app/core/_shared/models/LocalServerStatus";
import { LocalServerService } from "../../local-server.service";



@Injectable()
export class WebApiConnectionService {
  



    private resultSubject = new ReplaySubject<any[]>(1);
    private resultPrepareSubject = new ReplaySubject<any>(1);

    connection: signalR.HubConnection;

    private listeners: ChangeListener[] = [];
    private progressListeners: ProgressListener[] = [];
    active: boolean = true;
    private pendingStatusRequests = new Map<string, (status: LocalServerStatus) => void>();

    public localServerStatus: LocalServerStatus;


    constructor(private _http: HttpClient,
        private _webApi: WebApiService, private _userService: UserService,
        private _router: Router,
        private userActivityService: UserActivityService) {
        this.tryStartSignalRConnection(0);

        this.userActivityService.isUserActive$.subscribe(active => {
            this.active = active;
            if (!active) {

                console.log('Usuário inativo — encerrando conexão SignalR');
                this.connection.stop();
            } else {
                console.log('Usuário ativo — iniciando/reconectando SignalR');

            }
        });
    }

    private registerSignalRCallbacks(): void {
        // Callback para GetBetItemsFromFile
        this.connection.on("CallbackGetBetItemsFromFile", (items: any[]) => {
            this.resultSubject.next(items);
        });

        // Callback para PrepareBetToDownload
        this.connection.on("CallbackPrepareBetToDownload", (result: any) => {
            console.log("callbackPrepareBetToDownload", result);
            this.resultPrepareSubject.next(result);
        });

        this.connection.on("CallbackListener", (controlId: string, path: string, value: any) => {
            let jsonValue = JSON.parse(value);


            this.listeners.forEach(changeListener => {
                if (changeListener.Mach(jsonValue, path, controlId)) {
                    changeListener.Fire(jsonValue);
                }
            });
        });



        this.connection.on("ProgressUpdated", (key: string, value: number) => { });

        this.connection.on("NewServerOnLine", () => {
            this.reconectListeners();
        });

        this.connection.on("CallbackClientServerStatus", (status: LocalServerStatus) => {

            this.localServerStatus = status;

            this.localServerStatus.LastChecked = new Date();
            // this._localServerService.updateStatus(status);

        });
    }

    getBetItemsFromFile(
        machineName: string, userId: string, lotteryId: string, betId: string,
        solutionFileName: string, newPageIndex: number, length: number, skip: number
    ): Observable<any[]> {
        if (!machineName) machineName = "ServerMain";

        if (!this.connection || this.connection.state !== "Connected") {
            console.warn("SignalR connection is not established. Aborting send.");
            return throwError(() => new Error("SignalR connection not established."));
        }

        const subject = new ReplaySubject<any[]>(1);

        const callback = (items: any[]) => {
            subject.next(items);
            subject.complete();
            this.connection.off("CallbackGetBetItemsFromFile", callback);
        };

        this.connection.on("CallbackGetBetItemsFromFile", callback);

        this.connection.send(
            "GetBetItemsFromFile",
            machineName, userId, lotteryId, betId, solutionFileName, newPageIndex, length, skip
        ).catch(err => {
            console.error("Error sending GetBetItemsFromFile:", err);
            subject.error(err);
            this.connection.off("CallbackGetBetItemsFromFile", callback);
        });

        return subject.asObservable();
    }


    refreshLocalServerStatus(
        publicIp: string,
        clientCookieIdentifier: string,
        userId: string,
        userEmail: string
    ) {


        if (!this.connection || this.connection.state !== "Connected") {
            return Promise.reject("SignalR connection not established.");
        }

        this.connection.invoke(
            "RefreshClientServerStatus",
            publicIp,
            clientCookieIdentifier,
            userId,
            userEmail
        )
            .catch(err => {
                // // falha ao enviar → limpar e rejeitar
                // this.pendingStatusRequests.delete(requestId);
                //reject(err);
            });

        //  });
    }

    sendPrintBet(  publicIp: string,
        clientCookieIdentifier: string,
        userId: string,
        userEmail: string, message: any) {

         this.connection.invoke(
            "SendToLocalServer",
            publicIp,
            clientCookieIdentifier,
            userId,
            userEmail, 
            "printBet",
            message
        )
        .catch(err => {
            console.error('❌ Erro ao enviar SendPrintBet:', err);
        }
        );
    }

    sendToLoteriasOnLine(  publicIp: string,
        clientCookieIdentifier: string,
        userId: string,
        userEmail: string, message: any) {

         this.connection.invoke(
            "SendToLocalServer",
            publicIp,
            clientCookieIdentifier,
            userId,
            userEmail, 
            "loteriasOnLine",
            message
        )
        .catch(err => {
            console.error('❌ Erro ao enviar SendToLoteriasOnLine:', err);
        }
        );
    }




    prepareBetToDownload(
        machineId: string, userId: string, lotteryId: string, betId: string, solutionFileName: string
    ): Observable<any> {
        if (!machineId) machineId = "ServerMain";

        if (!this.connection || this.connection.state !== "Connected") {
            console.warn("SignalR connection is not established. Aborting send.");
            return throwError(() => new Error("SignalR connection not established."));
        }

        const subject = new ReplaySubject<any>(1);

        const callback = (result: any) => {
            console.log("CallbackPrepareBetToDownload", result);
            subject.next(result);
            subject.complete();
            this.connection.off("CallbackPrepareBetToDownload", callback);
        };

        this.connection.on("CallbackPrepareBetToDownload", callback);

        this.connection.send(
            "PrepareBetToDownload", machineId, userId, lotteryId, betId, solutionFileName
        ).catch(err => {
            console.error("Error sending PrepareBetToDownload:", err);
            subject.error(err);
            this.connection.off("CallbackPrepareBetToDownload", callback);
        });

        return subject.asObservable();
    }

    private async tryStartSignalRConnection(retries: number) {
        let isLogged = await this._userService.isUserLogged();

        if (isLogged && this.active) {
            this.startSignalRConnection(retries);
        } else {
            setTimeout(() => {
                this.tryStartSignalRConnection(0);
            }, 5000);
        }
    }

    public startSignalRConnection(retries: number) {
        this.connection = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Information)
            .withUrl(this._webApi.GetApiAddress() + "/notify", { accessTokenFactory: () => localStorage.getItem(environment.authTokenKey) })
            .withAutomaticReconnect() // ← ativa reconexão automática
            .build();

        console.log("Tentando conectar ao SignalR..." + this._webApi.GetApiAddress() + "/notify");

        this.connection.start().then(() => {
            console.log("Conectado ao SignalR");
            this.registerSignalRCallbacks(); // <-- Chave: registra todos os listeners uma vez.
            this.reconectListeners();
        }).catch(err => {
            console.error("Erro de conexão com SignalR: " + err.toString());
            setTimeout(() => {
                this.tryStartSignalRConnection(retries + 1);
            }, 3000);
        });

        this.connection.onreconnecting(() => {
            console.warn('Tentando reconectar ao SignalR...');
        });

        this.connection.onreconnected(() => {
            console.log('Reconectado ao SignalR.');
            this.reconectListeners();
        });

        this.connection.onclose(() => {

            this.stopListeners();
            this.pendingStatusRequests.clear();
            setTimeout(() => {
                this.tryStartSignalRConnection(0);
            }, 3000);
        });


    }

    addListener(changeListener: ChangeListener) {
        this.listeners.push(changeListener);
        changeListener.Listen(this.connection);
    }

    addProgressListener(progressListener: ProgressListener) {
        this.progressListeners.push(progressListener);
    }

    reconectListeners() {
        this.listeners.forEach(changeListener => {
            changeListener.Fire(null);
            changeListener.Listen(this.connection);
        });
    }

    stopListeners() {
        this.listeners.forEach(changeListener => {

            changeListener.StopAsync(this.connection);
        });
    }

    // fireAllListeners() {
    //     this.listeners.forEach(changeListener => {
    //         changeListener.Fire(null);
    //     });
    // }
    removeListener(changeListener: ChangeListener) {
        this.listeners = this.listeners.filter(x => x !== changeListener);
        changeListener.StopAsync(this.connection);
    }

    removeProgressListener(progressListener: ProgressListener) {
        this.progressListeners = this.progressListeners.filter(x => x !== progressListener);
    }


    deleteDocument(path: string): Promise<void> {

        var body: MongoBody = {
            path: path,
            data: null,
            queryOperations: null
        };

        return this._http.post<MongoBody>(this._webApi.GetApiAddress() + `/mongo/DocumentReference/Delete`, body, httpOptions)
            .pipe(
                map(result => {
                    //  return result;
                }

                ))
            .toPromise();

    }

    addDocument(path: string, data: DocumentData): Promise<any> {


        var body: MongoBody = {
            path: path, data: data,
            queryOperations: null
        };

        return this._http.post(this._webApi.GetApiAddress() + `/mongo/DocumentReference/Add`, body, httpOptions)
            .pipe(
                map(result => {


                    return result;

                }

                )).toPromise();

    }

    setDocument(path: string, data: DocumentData): Promise<void> {

        var body: MongoBody = {
            path: path,
            data: data,
            queryOperations: null
        };

        return this._http.post(this._webApi.GetApiAddress() + `/mongo/DocumentReference/Set`, body, httpOptions)
            .pipe(
                map(result => {
                    //    return result;
                }

                ))
            .toPromise();

    }

    setFieldsDocument(path: string, data: DocumentData): Promise<void> {



        var body: MongoBody = {
            path: path,
            data: data,
            queryOperations: null
        };

        return this._http.post(this._webApi.GetApiAddress() + `/mongo/DocumentReference/SetFields`, body, httpOptions)
            .pipe(
                map(result => {
                    // return result.json();
                }

                ))
            .toPromise();

    }

    getDocumentSnapShot(path: string): Promise<DocumentData> {


        var body: MongoBody = {
            path: path, data: null,
            queryOperations: null
        };


        return this._http.post(this._webApi.GetApiAddress() + `/mongo/DocumentReference/GetSnapshotAsync`, body, httpOptions)
            .pipe(
                map(result => {

                    return result;

                }

                )).toPromise();

    }



    public getQuerySnapshot(path: string, queryOperations: QueryOperation[]): Promise<DocumentData[]> {


        var body: MongoBody = {
            path: path,
            data: null,
            queryOperations: queryOperations
        };


        return this._http.post(this._webApi.GetApiAddress() + `/mongo/Query/GetSnapshotAsync`, body, httpOptions)
            .pipe(
                map((result: DocumentData[]) => {

                    let list: DocumentData[] = result;

                    return list;

                }),
                catchError(err => { throw 'error in source. Details: ' + err; })
            ).toPromise();



    }

    public getQueryCount(path: string, queryOperations: QueryOperation[]): Promise<number> {


        var body: MongoBody = {
            path: path,
            data: null,
            queryOperations: queryOperations
        };


        return this._http.post(this._webApi.GetApiAddress() + `/mongo/Query/GetCountAsync`, body, httpOptions)
            .pipe(
                map((result: number) => {

                    return result;

                }),
                catchError(err => { throw 'error in source. Details: ' + err; })
            ).toPromise();

    }


    deleteCollection(path: string) {

        var body: MongoBody = {
            path: path,
            data: null,
            queryOperations: null
        };

        return this._http.post<MongoBody>(this._webApi.GetApiAddress() + `/mongo/CollectionReference/Delete`, body, httpOptions)
            .pipe(
                map(result => {
                    //  LottolocaDebugger.log(200,result);


                    return result;

                }

                ))
            .toPromise();

    }
}
